// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610012259/js/" + chunkId + "." + {"44":"0011a051","225":"f92ee313","481":"884c0002","486":"e5830ccb","770":"f51364d7"}[chunkId] + ".0.8331157543594508.chunk.js";
};